import classNames from 'classnames';

import { PlaintextEditor, PlaintextEditorProps, PlaintextEditorRef } from './PlaintextEditor';
import React, { forwardRef } from 'react';

export type PlaintextCellEditorProps = Omit<
	PlaintextEditorProps,
	'hideButtons' | 'saveOnBlur' | 'saveOnEnter' | 'saveOnTab' | 'showProcessing'
>;

export const PlaintextCellEditor = forwardRef<PlaintextEditorRef | null, PlaintextCellEditorProps>(({
	allowNewline,
	className,
	...rest
}, ref) =>
	<PlaintextEditor
		{ ...rest }
		allowNewline={ allowNewline }
		className={ classNames('plaintext-cell-editor', className) }
		hideButtons
		isSpreadsheet
		ref={ ref }
		saveOnBlur
		saveOnEnter
		saveOnTab
		showProcessing />);
